import { DictationSlotComponent } from '#pplx/frontend/composer-sdk-plugins/dictation/DictationSlotComponent.js';
import { DictationTranscriptSync } from '#pplx/frontend/composer-sdk-plugins/dictation/DictationTranscriptSync.js';
import { createPlugin } from '#pplx/frontend/composer-sdk/plugins/createPlugin.js';
import { createPluginFactory } from '#pplx/frontend/composer-sdk/plugins/createPluginFactory.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import { useMemo } from 'react';
const DICTATION_SUBMIT_PRIORITY = 50;
const createDictationTranscriptSyncPluginFactory = createPluginFactory({
    name: 'dictation-transcript-sync',
    capabilities: [
        {
            kind: 'slot',
            components: [{ slot: 'rightAttribution', component: DictationTranscriptSync }],
        },
    ],
});
export function createDictationPluginFactory() {
    return createPluginFactory({
        name: 'dictation',
        capabilities: [
            {
                kind: 'slot',
                components: [{ slot: 'rightAttribution', component: DictationSlotComponent }],
            },
        ],
    });
}
const createDictationControlPlugin = createDictationPluginFactory();
/**
 * Keeps each registration stable until its own inputs change.
 * @returns Transcript sync, microphone controls, and submit action, in that order.
 */
export function useControlledDictationPlugins({ focusRequest, isDisabled = false, isInitializing, isSubmitDisabled, isSupported, isTranscribing, onStartTranscription, onStopTranscription, onSubmit, startLabel, stopLabel, stopOnSubmitGesture, submitLabel, transcription, }) {
    const syncPlugin = useMemo(() => createDictationTranscriptSyncPluginFactory({
        focusRequest,
        isTranscribing,
        onStopTranscription,
        stopOnSubmitGesture,
        transcription,
    }), [focusRequest, isTranscribing, onStopTranscription, stopOnSubmitGesture, transcription]);
    const controlPlugin = useMemo(() => createDictationControlPlugin({
        isDisabled,
        isInitializing,
        isSupported,
        isTranscribing,
        onStartTranscription,
        onStopTranscription,
        startLabel,
        stopLabel,
    }), [
        isDisabled,
        isInitializing,
        isSupported,
        isTranscribing,
        onStartTranscription,
        onStopTranscription,
        startLabel,
        stopLabel,
    ]);
    const submitPlugin = useMemo(() => createPlugin({
        id: 'dictation-submit',
        capabilities: [
            {
                kind: 'primaryAction',
                id: 'dictation-submit',
                priority: DICTATION_SUBMIT_PRIORITY,
                when: () => isTranscribing,
                action: () => ({
                    ariaLabel: submitLabel,
                    icon: $icon('check'),
                    isDisabled: isSubmitDisabled,
                    onPress: onSubmit,
                }),
            },
        ],
    }), [isSubmitDisabled, isTranscribing, onSubmit, submitLabel]);
    return useMemo(() => [syncPlugin, controlPlugin, submitPlugin], [syncPlugin, controlPlugin, submitPlugin]);
}
//# sourceMappingURL=index.js.map